import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { EnvService } from '@src/app/modules/env';

@Component({
  selector: '[waitTelegramChats]',
  templateUrl: './wait-telegram-chats.component.html',
  styleUrls: ['./wait-telegram-chats.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaitTelegramChatsComponent {
  private readonly env = inject(EnvService);

  /** Параметр для отображения контента при загрузке */
  @Input() contentVisible = true;

  loadingChats$ = this.env.loadingChats$;
}
